module.exports = __webpack_public_path__ + "static/optim-51deb823ee1c9815a305ad10019c9a3e.png";